import { Component, OnInit, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { Contract } from './contract.model';
import { ContractService } from './contract.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

@Component({
    selector: 'jhi-contract',
    templateUrl: './contract.component.html'
})
export class ContractComponent implements OnInit, OnDestroy {
contracts: Contract[];
    currentAccount: any;
    eventSubscriber: Subscription;
    currentSearch: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private contractService: ContractService,
        private alertService: AlertService,
        private eventManager: EventManager,
        private activatedRoute: ActivatedRoute,
        private principal: Principal
    ) {
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['contract']);
    }

    loadAll() {
        if (this.currentSearch) {
            this.contractService.search({
                query: this.currentSearch,
                }).subscribe(
                    (res: Response) => this.contracts = res.json(),
                    (res: Response) => this.onError(res.json())
                );
            return;
       }
        this.contractService.query().subscribe(
            (res: Response) => {
                this.contracts = res.json();
                this.currentSearch = '';
            },
            (res: Response) => this.onError(res.json())
        );
    }

    search(query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    }

    clear() {
        this.currentSearch = '';
        this.loadAll();
    }
    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInContracts();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: Contract) {
        return item.id;
    }
    registerChangeInContracts() {
        this.eventSubscriber = this.eventManager.subscribe('contractListModification', (response) => this.loadAll());
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contract/contract.component.ts